import { render, staticRenderFns } from "./LDStat.vue?vue&type=template&id=0a0ea7d8&scoped=true&"
import script from "./LDStat.vue?vue&type=script&lang=js&"
export * from "./LDStat.vue?vue&type=script&lang=js&"
import style0 from "./LDStat.vue?vue&type=style&index=0&id=0a0ea7d8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a0ea7d8",
  null
  
)

export default component.exports